export const DimensionProperties = [
    {
        _group: {
            title: "General"
        },
        items: [
            {
                path: 'name',
                title: 'Name',
                type: 'string',
                allowEmpty: false
            },
            {
                path: 'description',
                title: 'Description',
                type: 'string'
            },
            {
                path: 'show_home_page',
                title: 'Show Home Page',
                type: 'bool'
            },
            {
                path: 'access.mode',
                title: 'Visibility',
                type: 'enum',
                items: ['Public', 'Private'],
                defaultValue: 'Private'
            }
        ]
    }
];

export const LocationProperties = [
    {
        _group: {
            title: "General"
        },
        items: [
            {
                path: 'enabled',
                title: 'Enabled',
                type: 'bool',
                defaultValue: true
            },
            {
                path: 'name',
                title: 'Name',
                type: 'string',
                allowEmpty: false
            }
        ]
    }
    /*,
    {
        _group: {
            title: "Lighting"
        },
        items: [
            {
                path: 'scene.lighting.enabled',
                title: 'Enabled',
                type: 'bool'
            },
            {
                path: 'scene.lighting.type',
                title: 'Type',
                type: 'enum',
                items: ['Directional', 'Ambient'],
                defaultValue: 'Directional'
            },
            {
                path: 'scene.lighting.position',
                title: 'Position',
                type: 'float3'
            },
            {
                path: 'scene.lighting.direction',
                title: 'Direction',
                type: 'float3'
            },
            {
                path: 'scene.lighting.ambient_color',
                title: 'Ambient Color',
                type: 'float4'
            },
            {
                path: 'scene.lighting.diffuse_color',
                title: 'Diffuse Color',
                type: 'float4'
            },
            {
                path: 'scene.lighting.shadow_enabled',
                title: 'Shadow',
                type: 'bool'
            },
            {
                path: 'scene.lighting.shadow_map_size',
                title: 'Shadow Map Size',
                type: 'integer'
            },
            {
                path: 'scene.lighting.shadow_softness',
                title: 'Shadow Softness',
                type: 'float'
            },
            {
                path: 'scene.lighting.shadow_darkness',
                title: 'Shadow Darkness',
                type: 'float'
            },
            {
                path: 'scene.lighting.shadow_decay_dist',
                title: 'Shadow Decay Distance',
                type: 'float'
            }
        ]
    }
*/
];